import styled from 'styled-components';
import { Text } from '../../CommonComponents/OPL/Text/Text';
import { BREAKPOINTS } from '../BeFi20.meta';
import { Wrapper as WrapperBase } from '../BeFi20.styles';

export const Wrapper = styled(WrapperBase)({
  paddingTop: 0,
  alignItems: 'unset',
  justifyContent: 'unset',
  overflowX: 'clip',

  [`@media (min-width: ${BREAKPOINTS.sm})`]: {
    minHeight: 880,
  },
});

export const KeyboardShortcut = styled(Text).attrs({ as: 'span', variant: 'smallCaps' })({
  width: 18,
  height: 18,
  borderRadius: '3px',
  border: `1px solid currentColor`,
  textAlign: 'center',
  display: 'none',
  color: 'currentColor',
  lineHeight: '17px',

  [`@media (min-width: ${BREAKPOINTS.sm})`]: {
    display: 'block',
  },
});
